module.exports = __webpack_public_path__ + "img/video_icon.11fe7c66.png";